import { Component, OnInit,ViewChild,AfterViewInit } from '@angular/core';
import { HrmsService,MasterService,AuthService } from '../../services/index';
import {Router,ActivatedRoute,Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router'
import { AppGlobals } from '../../shared/app.global';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-employs',
  templateUrl: './employs.component.html',
  styleUrls: ['./employs.component.scss'],
  providers:[HrmsService,AppGlobals,MasterService,AuthService]
})
export class EmploysComponent implements OnInit {

  studentarr:any[];
  depts:any[];
  catgories:any[];
  photo:any='';
 
  @ViewChild('dt') table: any;
  closeResult: string;
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  arrdesig:any=[];
  arrdesig1:any=[];
  arrdept:any=[];
  arrrolesall:any=[];
  arrdept1:any=[];
  arrsubject:any=[];
  bloodgp:any=[];
 classes:any=[];
 sections:any=[];
 arrallocations:any=[];
  oprtype:string;
  atltype:string;
  objstudent:any={};
  objclsteach:any={};
  admdash:any={};
  arrmtongue:any=[];
  objsubalot:any={};
  selemp:any={};
  arrstudoctype:any=[];
  stuclass:any=[];
  arrclassteachers:any=[];
  stucourse:any=[];
  selemp1:any={};
  stuid;
  alclnew:boolean=true;
  arrpaycat:any=[];
  arrempcat:any=[];
  objfilt:any={desid:'0',depid:'0',fieldnm:'emcatid'};

  arrstatus=[{name:'Active'},{name:'Inactive'}];

    
  //=[{'id':'1','name':'English'},{'id':'2','name':'Hindi'}];
  tab=1;
  tab1=1;
  selcat:any=0;
  verifiedstatus:any;
  genders:any=[{value:'Male',name:'Male'},{value:'Female',name:'Female'},{value:'Trans',name:'Trans'}];
  statuses:any=[{value:'Active',name:'Active'},{value:'Inactive',name:'Inactive'}];
  marstatuses:any=[{value:'Married',name:'Married'},{value:'Single',name:'Single'}];

  fileToUpload: File = null;

fData: FormData = new FormData;

signfileToUpload: File = null;

signfData: FormData = new FormData;
dcid:any=0;
arrstudoc:any=[];
arrcourse:any=[];
disuploadbtn=true;
objbulkfilter:any={};
arrfields:any=[];
arrstulist:any=[];
objfieldsel:any={fieldnm:'emcatid'};
arremp:any=[];
arremp1:any=[];
defclass:any=0;
defcorse:any=0;
defstat='Active';
studentarr1:any=[];
  objmnrts: any={};
  arrstaff: any=[];
  // objfieldsel:any={};

  constructor(private http: HttpClient,private aservice:AuthService, private mservice:MasterService,private hservice: HrmsService,private modalService: NgbModal,private apglobal:AppGlobals,private router: ActivatedRoute)  { }

  ngOnInit(): void {
     this.getmenuinfo(this.router.snapshot.url[0].path);
    this.getstudents();
    this.getdesignation();
    this.gethrmdept();
    this.selempcat();
  }

   getmenuinfo(mid) {
    this.mservice.getmenuinfo(mid)
    .subscribe(
     resultArray =>
     { 
      console.log('menuinfo',resultArray);
      this.objmnrts=resultArray;
      // this.mascourse();
       //this._postsArray = resultArray;
      // this.formatmenudata(resultArray);
   // console.log('menus',JSON.stringify(resultArray));
    }
,
     error => console.log("Error :: " + error)
 )
}

  gethrmdept() {
    this.mservice.get_hrmdept()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrdept = resultArray;
            this.arrdept1=resultArray;
// this.arrdept1.unshift({depid:"0",depnm:"ALL"});
this.defclass="0";
           
        },
        error => console.log("Error :: " + error)
        )
  }

    dumpstaffdata() {
      debugger
    this.hservice.dumpstaffdata()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            alert (resultArray.message);
           
        },
        error => console.log("Error :: " + error)
        )
  }


   
updatestudentbulk()
{
  
  var result = confirm("Are you sure you want to modify details?");

  if(result)
  {
  this.hservice.updatestaffbulk(this.arrstaff,this.objfieldsel.fieldnm)
  .subscribe(result => {
      console.log('ret',JSON.stringify(result));
      alert (result.message);
      if(result.status=='Success')
{
  
//this.getstudents('s',0);

}
      //this.alertmessage=result.message;
  
 // this.Getclasslist();
  }, error => 
  alert('error in connection')

  
  //this.alertmessage='error in connection'
  );
  }
}


  getdesignation() {
    this.mservice.sel_sp_hrmdesig()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrdesig = resultArray;

            this.arrdesig1=resultArray;
// this.arrdesig1.unshift({desid:"0",desnm:"ALL"});
this.defcorse="0";
           
        },
        error => console.log("Error :: " + error)
        )
  }


  getstudents() {
    this.hservice.getemployes()
        .subscribe(
        resultArray => {
            console.log('getlibdepartment', resultArray);
            this.studentarr = resultArray.emplst;
            this.studentarr1 = resultArray.emplst;
          var activeemps   = resultArray.emplst.filter(function(arr)
            {
        
              return arr.emstatus=='Active';
            });
            this.arremp= activeemps.map( o => { return { emid: o.emid, emnm: o.emnm} });
            this.admdash=resultArray.empinfo;
            console.log('arremp',this.arremp);
            this.onchangefilters();
            
        },
        error => console.log("Error :: " + error)
        )
  }


selstaff() {
    this.hservice.selstaff(this.objfilt.desid, this.objfilt.depid)
        .subscribe(
        resultArray => {
            console.log('getlibdepartment', resultArray);
            this.arrstaff = resultArray;
           
            
        },
        error => console.log("Error :: " + error)
        )
  }

  getsubjects(clid,crid) {
debugger
    var clid1={clid:clid,crid:crid};
    this.mservice.masclasssubject(clid1)
        .subscribe(
        resultArray => {
            console.log('subjects', resultArray);
            this.arrsubject = resultArray;
            
            
        },
        error => console.log("Error :: " + error)
        )
  }


  filteremp(event) {
    //in a real application, make a request to a remote url with the query and return filtered results, for demo we filter at client side
    let filtered: any[] = [];
    let query = event.query;
    for (let i = 0; i < this.arremp.length; i++) {
      let country = this.arremp[i];
      if (country.emnm.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(country);
      }
    }

    this.arremp1 = filtered;
  }

  onpubselectEvent(item) {
    //alert('hi');
        console.log('item',item);
        this.objsubalot.emid=item.emid;
        //this.selmember=item;
        //this.getissuedbookinfocnts(item.id);
      //  this.getissueddetails();
        // do something with selected item
      }


      onempselectEvent(item) {
        //alert('hi');
            console.log('item',item);
            this.objclsteach.emid=item.emid;
            //this.selmember=item;
            //this.getissuedbookinfocnts(item.id);
          //  this.getissueddetails();
            // do something with selected item
          }
  onpubChangeSearch(sertxt) {
    debugger
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
    // if(sertxt.query.length>=3) 
    // {
    //   this.serlibpublisher(sertxt.query);
    // }
  }

  onchangefilters()
{
  debugger
if(this.defclass=="0" && this.defcorse=="0" )
{

  this.studentarr=this.studentarr1.filter(item => item.emstatus===this.defstat);
}

else if(this.defclass!="0" && this.defcorse!="0" )
{

  this.studentarr=this.studentarr1.filter(item => item.emstatus===this.defstat && item.depid===this.defclass && item.desid===this.defcorse);
}

// else if(this.defclass!="0" && this.defcorse!="0" )
// {

//   this.studentarr=this.studentarr1.filter(item => item.stustatus===this.defstat && item.clid===this.defclass && item.crid===this.defcorse);
// }

else if(this.defclass!="0" && this.defcorse==="0" )
{

  this.studentarr=this.studentarr1.filter(item => item.emstatus===this.defstat && item.depid===this.defclass );
}

else if(this.defclass==="0" && this.defcorse!="0" )
{

  this.studentarr=this.studentarr1.filter(item => item.emstatus===this.defstat && item.desid===this.defcorse );
}
  //if()
}

masclass() {
  this.mservice.masclass()
      .subscribe(
      resultArray => {
          console.log('getdashcounts', resultArray);
          this.classes = resultArray;
          this.objsubalot.clid=resultArray[0].clid;
         // this.getsubjects(resultArray[0].clid);
//           this.arrclass1=resultArray;
// this.arrclass1.unshift({clid:"0",clnm:"ALL"});
// this.defclass="0";
         this.mascourse();
      },
      error => console.log("Error :: " + error)
      )
}

mascourse() {
  this.mservice.mascourse()
      .subscribe(
      resultArray => {
          console.log('getdashcounts', resultArray);
          this.arrcourse = resultArray;
          this.objsubalot.crid=resultArray[0].crid;
          this.getsubjects(this.objsubalot.clid,this.objsubalot.crid)
         
         
      },
      error => console.log("Error :: " + error)
      )
}
massection() {
  this.mservice.massection()
      .subscribe(
      resultArray => {
          console.log('getdashcounts', resultArray);
          this.sections = resultArray;
          this.objsubalot.scid=resultArray[0].scid;
      },
      error => console.log("Error :: " + error)
      )
}

gethrsuballocation() {
  this.atltype="Subject";
  this.hservice.hrsubjectallocation()
      .subscribe(
      resultArray => {
          console.log('getdashcounts', resultArray);
          this.arrallocations = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}

masmtongue() {
  this.mservice.getmasmtongue()
      .subscribe(
      resultArray => {
          console.log('arrmtongue', resultArray);
          this.arrmtongue = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}

masbloodgroup() {
  this.mservice.masbloodgroups()
      .subscribe(
      resultArray => {
          console.log('bloodgp', resultArray);
          this.bloodgp = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}


selpaycat() {
  this.hservice.paycategory()
      .subscribe(
      resultArray => {
          console.log('bloodgp', resultArray);
          this.arrpaycat = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}

selempcat() {
  this.hservice.empcategory()
      .subscribe(
      resultArray => {
          console.log('bloodgp', resultArray);
          this.arrempcat = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}


getempdetails(emid) {
  this.hservice.selemploy_details(emid)
      .subscribe(
      resultArray => {
          console.log('objstudent', resultArray);
          this.objstudent = resultArray;
          this.objstudent.oprtype='update';
         
      },
      error => console.log("Error :: " + error)
      )
}
gethrclassteacher() {
  this.atltype="Incharge";
  this.hservice.hrclassteacher()
      .subscribe(
      resultArray => {
          console.log('getdashcounts', resultArray);
          this.arrclassteachers = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}


protected getrolesall() {
  this.aservice.getroles('selall')
      .subscribe(
      resultArray => {
          console.log('arrrolesall', resultArray);
          this.arrrolesall = resultArray;
        //  this.objstfdata.clid=resultArray[0].desid;
          //this.objstfdata.defblgrp=resultArray[0].blgpnm;
         
      },
      error => console.log("Error :: " + error)
      )
}

opensubalot(content,objdata,cmd) {
debugger;
this.oprtype=cmd;
  console.log('obj',objdata);
  this.arremp1=this.arremp;
  this.masclass();
  this.massection();
  
  if(cmd=='insert')
  {
    
    this.objsubalot={};
    this.objsubalot.rid='0';
    this.objsubalot.altype=this.atltype;
    // this.objsubalot.clid=this.classes[0].clid;
    // this.objsubalot.scid=this.sections[0].scid;
    if(this.arrsubject == undefined )
    {this.objsubalot.suid='0';}
     else if(this.arrsubject.length>0)
    {
      this.objsubalot.suid=this.arrsubject[0].subid;
    }
    else{

      this.objsubalot.suid='0';
    }
    //this.getsubjects(this.classes[0].clid);
    //this.objsubalot.sbid=this.arrsubject[0].sbid;
    // this.objsec.desid=0;
    // this.objsec.sort='';
   
    this.objsubalot.oprtype='insert';
   

  }

  else if(cmd=='update')
  {
   this.getsubjects(objdata.clid,objdata.crid);
    this.objsubalot=objdata;
    this.selemp.emid=objdata.emid;
    this.selemp.emnm=objdata.emnm;
    //this.getsubjects(objdata.clid);
    this.objsubalot.oprtype='update';
    this.objsubalot.altype=this.atltype;
  }
  
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'sm'
   
   
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       
    }, (reason) => {
        
    });
}


saveemploy(objstudent)
{
  debugger;
  
  console.log(JSON.stringify(objstudent));
  

  this.hservice.saveemployee(objstudent)
  .subscribe(result => {
      console.log('ret',JSON.stringify(result));
      alert (result.message);
      if(result.status=='Success')
{
  let localmodref=this.modalRef;
localmodref.close();
this.getstudents();

}
      //this.alertmessage=result.message;
  
 // this.Getclasslist();
  }, error => 
  alert('error in connection')

  
  //this.alertmessage='error in connection'
  );

}
openemployee(content,objdata,cmd) {
  debugger;
  this.oprtype=cmd;
    console.log('obj',objdata);
   
    this.selpaycat();
    this.masbloodgroup();
    this.masmtongue();
    this.selempcat();
    this.getrolesall();
    if(cmd=='insert')
    {
      this.objstudent={};
      this.objstudent.emid='0';
      this.objstudent.euin='';
      this.objstudent.emnm='';
      this.objstudent.dob=this.apglobal.getdatetoday();
      this.objstudent.gender='Male';
      this.objstudent.bgid='1';
      this.objstudent.mtid='16';
      this.objstudent.pob='';
      this.objstudent.nationality='';
      this.objstudent.religion='';
      this.objstudent.caste='';
      this.objstudent.subcaste='.';
    
     this.objstudent.fatnm='';
     this.objstudent.fatemail='';
     this.objstudent.fatprof='';
     //this.objstudent.fatedu='';
     this.objstudent.fatmobile='';
     this.objstudent.motemail='';
     this.objstudent.motmobile='';
     this.objstudent.motnm='';
     this.objstudent.motprof='';
    //  this.objstudent.motedu='';
     this.objstudent.spoemail='';
     this.objstudent.spomobile='';
     this.objstudent.sponm='';
     this.objstudent.spoprof='';
     

     this.objstudent.emmobile='';
     this.objstudent.ememail='';
     this.objstudent.address='';
     this.objstudent.city='';
     this.objstudent.pin='';
     this.objstudent.latitude='';
     this.objstudent.logitude='';
     this.objstudent.state='';
     this.objstudent.country='India';
      this.objstudent.desid=this.arrdesig[0].desid;
      this.objstudent.depid=this.arrdept[0].depid;
      this.objstudent.emcatid=this.arrempcat[0].emcatid;
      this.objstudent.paycatid=this.arrpaycat[0].pctid;
      this.objstudent.rlid=this.arrrolesall[0].roid;
      // euin,emnm,dob,gender,bgid,mtid,pob,nationality,religion,
      //   caste,subcaste,insid,doj,desid,depid,emcatid,paycatid,eduinfo,
      //   emstatus,dor,aadhaar,pan,epf,esi,bkacnm,bkacno,bknm,bkbrnm,
      //   bkbrcd,marital,dom,fatnm,fatprof,fatmobile,fatemail,motnm,motprof,
      //   motmobile,motemail,sponm,spoprof,spomobile,spoemail,address,area,
      //   city,pin,state,country,latitude,logitude,emmobile,ememail,rlid,
      //   elp
      this.objstudent.eduinfo='';
      this.objstudent.emstatus='Active';
      this.objstudent.aadhaar='';
      this.objstudent.pan='';
      this.objstudent.epf='';
      this.objstudent.esi='';
      this.objstudent.bkacnm='';
      this.objstudent.bkacno='';
      this.objstudent.bknm='';
      this.objstudent.bkbrnm='';
      this.objstudent.bkbrcd='';
      this.objstudent.marital='Married';
      this.objstudent.dom=this.apglobal.getdatetoday();
      this.objstudent.dor='';
      this.objstudent.doj=this.apglobal.getdatetoday();
     
      this.objstudent.oprtype='insert';
     
  
    }
  
    else if(cmd=='update')
    {
      this.getempdetails(objdata.emid);
      //this.objstudent=objdata;
      // this.selemp.emid=objdata.emid;
      // this.selemp.emnm=objdata.emnm;
      //this.getsubjects(objdata.clid);
     
    }
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'lg'
     
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }

openclsteach(content,objdata,cmd) {
  this.arremp1=this.arremp;
  this.oprtype=cmd;
  this.masclass();
  this.massection();
  
  if(cmd=='insert')
  {
    this.objclsteach={};
    //this.objclsteach.rid='0';
    this.objclsteach.clid=this.classes[0].clid;
    this.objclsteach.scid=this.sections[0].scid;
   
   
    this.objclsteach.oprtype='insert';
   

  }

  else if(cmd=='update')
  {
   
    this.objclsteach=objdata;
    this.selemp1.emid=objdata.emid;
    this.selemp1.emnm=objdata.emnm;
    //this.getsubjects(objdata.clid);
    this.objclsteach.oprtype='update';
  }
  
  this.objclsteach.altype=this.atltype;
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'sm'
   
   
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       
    }, (reason) => {
        
    });
}


deleteallocation(obj)
{

  console.log(obj);
if(confirm("Are you sure,you wan't to delete ?"))
{
  let pstvar=obj;
  pstvar.oprtype='delete';

  this.hservice.savehrmsubalot(pstvar)
      .subscribe(
      resultArray => {
          console.log('getdashcounts', resultArray);
          alert(resultArray.message);

          if(resultArray.status=='success')
{
  if(this.atltype=="Subject")
  {
this.gethrsuballocation();
  }

  else{
    this.gethrclassteacher();
  }

}
          
         
      },
      error => console.log("Error :: " + error)
      )
}}
savealotdetails()
{

  console.log('alotdet',this.objsubalot);

  if(this.objsubalot.suid=='0' || this.objsubalot.suid==undefined)
  {
    alert('please choose subject');
  }

  else if(this.objsubalot.emid=='' || this.objsubalot.emid==undefined)
  {
    alert('please choose teacher');
  }
  else{
  this.hservice.savehrmsubalot(this.objsubalot)
      .subscribe(
      resultArray => {
          console.log('getdashcounts', resultArray);
          alert(resultArray.message);

          if(resultArray.status=='success')
{
  let localmodref=this.modalRef;
localmodref.close();
if(this.atltype=="Subject")
  {
this.gethrsuballocation();
  }

  else{
    this.gethrclassteacher();
  }

}
          
         
      },
      error => console.log("Error :: " + error)
      )
    }
 // console.log('selemp',this.selemp.emid);
}


deleteclassteacher(obj)
{

  console.log(obj);
if(confirm("Are you sure,you wan't to delete ?"))
{
  let pstvar=obj;
  pstvar.oprtype='delete';

  this.hservice.savehrclassteacher(pstvar)
      .subscribe(
      resultArray => {
          console.log('getdashcounts', resultArray);
          alert(resultArray.message);

          if(resultArray.status=='success')
{
  
this.gethrclassteacher();

}
          
         
      },
      error => console.log("Error :: " + error)
      )
}}

saveclsteacher()
{
  this.objclsteach.crid='0';
  this.objclsteach.suid='0';
  this.objclsteach.rid='0';
  console.log('alotdet',this.objclsteach);

 
   if(this.objclsteach.emid=='' || this.objclsteach.emid==undefined)
  {
    alert('Please choose teacher');
  }
  else{
  this.hservice.savehrmsubalot(this.objclsteach)
      .subscribe(
      resultArray => {
          console.log('getdashcounts', resultArray);
          alert(resultArray.message);

          if(resultArray.status=='success')
{
  let localmodref=this.modalRef;
localmodref.close();
this.gethrclassteacher();

}
          
         
      },
      error => console.log("Error :: " + error)
      )
    }
 // console.log('selemp',this.selemp.emid);
}

exportrecord(){
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');
   //var url=this.liservice.callurl+"export/expstudent.php?clcd="+clcd+"&aycd="+aycd+"&oprtype="+oprtype+"&clid="+this.defclass+"&crid="+this.defcorse;
   var url=this.hservice.callurl+"export/expstaff.php?clcd="+clcd+"&aycd="+aycd;

   window.open(url,'','');
 }


 openinfo(content,bkid,photo)
 {
  
   this.stuid=bkid;
  this.photo=photo;
   this.modalOptions = {
     backdrop:'static',
     backdropClass:'customBackdrop',
     size:'lg'
    }
   this.modalRef=this.modalService.open(content,this.modalOptions);
   
   this.modalRef.result.then((result) => {
  
        // this.Asmtdetls(asid);
         this.closeResult = `Closed with: ${result}`;
     }, (reason) => {
         //this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
     });
 }
 
 
upload(files: FileList) {
  debugger;
  this.fileToUpload = files.item(0);

  this.fData.append("emid", this.stuid.toString());
  //this.fData.append("dcid", this.dcid.toString());
  //this.fData.append("docpurpose", "Studentphoto");

  // this.SService.uploadFile(fData).subscribe(
  //     response => this.handleResponse(response),
  //     error => this.handleError(error)
  // )
}


printidcard(memid,type){
  debugger
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');
   var url=this.hservice.callurl+"qrcode/"+type+".php?tag=stf&clcd="+clcd+"&aycd="+aycd+"&memid="+memid;

   window.open(url,'');
 }
fileupload()
{
debugger

console.log('file data',JSON.stringify(this.fileToUpload));

this.hservice.uploadphoto(this.fileToUpload,this.stuid)
.subscribe(fresult => {
   // console.log('ret',JSON.stringify(fresult));
    alert (fresult.message);
    if(fresult.status=='Success')
{
// let localmodref=this.modalRef;
// localmodref.close();
//this.Refreshsummary();
this.fileToUpload=null;
this.dcid=0;
this.disuploadbtn=true;
this.photo=fresult.updfilepath;

}
    
}, error => 
alert('error in connection')

);



}

}
